import React from "react";
import './Home.css';

export default function () {

    return (

        <section className="Sec-1 position-relative">

            <div className="position-absolute top-50 start-50 translate-middle">
                <h1 className="text-center text-white text-uppercase fw-bold pb-md-4">hello, this is web & mobile studio</h1>
               
            </div>

            <div className=" btn-1 text-center ">
                    <button type="button" className="btn-text"><span className="fw-bold fs-4 text-white">Hello</span></button>
                </div>
           
        </section>

    )

}